import React, { useEffect } from 'react';
import { PermissionApi } from '../../../../services/PermissionApi';

// Components
import TablePermissions from '../../tables/TablePermissions';

// Styles
import {
    Container,
    Header,
    Body,
    Footer,
    SectionRight
} from './styles'

// Utils
import { CustomButtonV2, ModalFooter, ModalHeader, ModalSubHeader } from '../../../../pages/styles';
import { useTranslation } from 'react-i18next'

export const ListPermissions = ({ roleId, title, handleClose }) => {
    const { t } = useTranslation();
    const permissionApi = new PermissionApi();

    const refData = React.useRef(false)

    const [filteredRequest, setFilteredRequest] = React.useState([])
    const [rows, setRows] = React.useState([])

    useEffect(() => {
        if (refData.current === false) {
            permissionApi.list(roleId).then((response) => {
            if (response?.status === 200) {
                let resp = response.data.data;
                setFilteredRequest(resp)
                setRows(resp)
            }
          })
          refData.current = true
        }
    }, [permissionApi, roleId])

    return (
        <Container>
            <ModalHeader>{title}</ModalHeader>
			<ModalSubHeader/>
            <Body>
                <TablePermissions 
                    filteredRequest={filteredRequest}
                    rows={rows}
                />
            </Body>
            <ModalFooter>
                <SectionRight>
                    <CustomButtonV2
						btnType="primary"
                        onClick={() => handleClose()}
                    >
                        {t('common.close')}
                    </CustomButtonV2>
                </SectionRight>
            </ModalFooter>
        </Container>
    )
}